<template>
  <v-expansion-panels v-if="canManage" flat class="timer-ex-members mx-2 mb-2">
    <v-expansion-panel>
      <v-expansion-panel-header class="timer-ex-members-header">
        <span>
          Not currently working
          <span v-if="loaded" class="timer-ex-members-count">
            ({{ exMembers.length }})
          </span>
          <span class="timer-ex-members-only"> — roster admin only</span>
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <p v-if="loadError" class="timer-ex-members-error">{{ loadError }}</p>
        <p v-else-if="!loaded" class="timer-ex-members-muted">
          Loading roster…
        </p>
        <p v-else-if="exMembers.length === 0" class="timer-ex-members-muted">
          No one marked as not currently working.
        </p>
        <ul v-else class="timer-ex-members-list">
          <li v-for="m in exMembers" :key="m.id" class="timer-ex-members-row">
            <div class="timer-ex-members-meta">
              <strong>{{ m.full_name || "Member" }}</strong>
              <span v-if="m.email_address" class="timer-ex-members-email">{{
                m.email_address
              }}</span>
            </div>
            <v-btn
              small
              color="success"
              depressed
              :loading="busyId === m.id"
              :disabled="busyId != null && busyId !== m.id"
              @click="markWorking(m)"
            >
              Mark working
            </v-btn>
          </li>
        </ul>
        <p class="timer-ex-members-foot muted">
          Full cards and publish flags:
          <router-link to="/members">Members</router-link>
        </p>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {userCanManageTeamRosterStatus} from "@/Utilites/teamRosterAdmin";
import DEFAULT_CONSTANTS from "@/Utilites/constants";

export default {
  name: "TimerExMembersPanel",
  data() {
    return {
      loaded: false,
      loadError: "",
      roster: [],
      busyId: null,
    };
  },
  computed: {
    ...mapGetters(["userProfileData"]),
    canManage() {
      return userCanManageTeamRosterStatus(this.userProfileData);
    },
    exMembers() {
      return (this.roster || []).filter(
        (m) => m.is_currently_working === false
      );
    },
  },
  mounted() {
    if (this.canManage) {
      this.loadRoster();
    }
  },
  methods: {
    ...mapActions([
      "fetchTeamList",
      "toggleMemberWorkingFlag",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async loadRoster() {
      this.loadError = "";
      try {
        await this.fetchTeamList({includeNotWorking: true});
        this.roster = [...(this.$store.state.member.teams || [])];
        this.loaded = true;
      } catch (err) {
        this.loadError =
          (err.response && err.response.data && err.response.data.detail) ||
          err.message ||
          "Could not load team roster.";
        this.loaded = true;
      }
    },
    async markWorking(member) {
      this.busyId = member.id;
      try {
        await this.toggleMemberWorkingFlag({
          memberId: member.id,
          isCurrentlyWorking: true,
        });
        await this.showSnackBar({
          text: `${member.full_name || "Member"} marked as currently working`,
          color: DEFAULT_CONSTANTS.success,
        });
        setTimeout(() => this.closeSnackBar(), DEFAULT_CONSTANTS.timeout);
        await this.loadRoster();
      } catch (err) {
        const detail =
          (err.response && err.response.data && err.response.data.detail) ||
          err.message ||
          "Update failed (is nekoapi migration 0058 deployed?)";
        await this.showSnackBar({
          text: String(detail),
          color: DEFAULT_CONSTANTS.error,
        });
        setTimeout(() => this.closeSnackBar(), DEFAULT_CONSTANTS.timeout);
      } finally {
        this.busyId = null;
      }
    },
  },
};
</script>

<style scoped>
.timer-ex-members-header {
  font-size: 0.95rem;
}
.timer-ex-members-count {
  font-weight: 600;
}
.timer-ex-members-only {
  font-weight: normal;
  opacity: 0.85;
  font-size: 0.85rem;
}
.timer-ex-members-list {
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
}
.timer-ex-members-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.timer-ex-members-row:last-child {
  border-bottom: none;
}
.timer-ex-members-meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.timer-ex-members-email {
  font-size: 0.8rem;
  opacity: 0.75;
}
.timer-ex-members-error {
  color: #ff8a80;
}
.timer-ex-members-muted,
.timer-ex-members-foot {
  font-size: 0.85rem;
  opacity: 0.85;
  margin: 0 0 8px;
}
.timer-ex-members-foot a {
  color: #90caf9;
}
</style>
